import React from 'react';
import { Switch, Route } from 'react-router-dom';
import VisitorLandingPage from './landingPage';
import { VisitorSignInStepper } from './signIn';
import { VisitorSignOutPage } from './signOut';
import NotFoundPage from '../routes/notFound';

const VisitorRoutes: React.FC = () => (
  <Switch>
    <Route
      path="/visitor/signIn"
      render={() => <VisitorSignInStepper returnUrl="/visitor" />}
    />
    <Route path="/visitor/signOut" component={VisitorSignOutPage} />
    <Route path="/visitor" component={VisitorLandingPage} />
    <Route component={NotFoundPage} />
  </Switch>
);

export default VisitorRoutes;
